<template>
    <div id="wrapper">
        <div class="nav-footer fixed-bottom" >
            <link rel="stylesheet" type="text/css" href="https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css">
            <!-- SOCIAL MEDIA HERE
            <div class="footerLinkTitle">Connect with us</div>
            <a href="https://www.facebook.com/pages/Brighton-Cromwell/164679050219729"  title="Facebook" target="_blank" style="margin-right: 20px;"><span class="fa fa-facebook"></span></a>
            <a href="https://twitter.com/BrightonCromwel" target="_blank" title="Twitter"><span class="fa fa-twitter" style="margin-right: 20px;"></span></a>
            <a href="https://www.linkedin.com/company/brighton-cromwell-llc" title="LinkedIn" target="_blank" style="margin-right: 20px;"><span class="fa fa-linkedin"></span></a>
            -->
        </div>

        <!-- End Sidebar -->
        <div id="page-wrapper" class="gray-bg" >
            <div class="main-background-image"></div>
            <div class="row setOpacity">
                <div class="top-bar top-bar-minimal topbarStyle">
                    <b-navbar class="">
                        <b-navbar-brand >
                            <img class="img-fluid logoStyle" src="/sednasearchlogo.png" width="70%"/>
                            <small class="text-muted logoCopyright">&copy; 2022</small>
                        </b-navbar-brand>
                        <b-navbar-nav class="ml-auto">
                            <!-- <b-nav-item href="https://www.atlassian.com/software/jira" target="_blank">Request Technical Support</b-nav-item> -->
                        </b-navbar-nav>
                    </b-navbar>

                </div>
            </div>

            <div class="wrapper wrapper-content" >
                <div class="container makeMeTransparent">
                    <router-view v-on:onError="onError"></router-view>
                </div>
            </div>
            
            <whats-new v-model="modalVisible"/>
            <error-view v-model="error" v-bind:disable_dismiss="error_disable_dismiss"/>
            
             
        </div>

        
    
            
    <!--
        

        <b-navbar toggleable="lg"  type="dark" variant="dark" class="p-3 px-md-4 mb-3 shadow-sm">
            <b-navbar-brand href="#/">Sedna Portal</b-navbar-brand>

            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav v-if="!publicRoute">
                <b-navbar-nav class="mr-auto">
                    <b-nav-item href="#/rfqs">RFQs</b-nav-item>
                    <b-nav-item href="#/quotes">Quotes</b-nav-item>
                </b-navbar-nav>

                <b-navbar-nav class="ml-auto">
                    <b-nav-text v-if="sessionUsername"><strong>{{sessionUsername}}</strong></b-nav-text>
                    <b-nav-item @click="modalVisible=true" >"How To" & What's New?</b-nav-item>
                    <b-nav-item href="https://www.atlassian.com/software/jira" target="_blank">Request Technical Support</b-nav-item>
                    <b-nav-form>
                        <a v-if="sessionUsername" class="btn btn-outline-light" href="#/signout">Sign out</a>
                        <a v-else class="btn btn-outline-light" href="#/signin">Sign in</a>
                    </b-nav-form>
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>

        <div class="container">
            <router-view v-on:onError="onError"></router-view>

            <app-layout-footer />
        </div>
    </div>
    -->
    
    </div>
</template>

<script>
//import LayoutFooter from '@/components/core/LayoutFooter'
import WhatsNew from '@/views/WhatsNew'
import ErrorView from '@/components/common/ErrorView';

export default {
    name: 'app-layout-minimal', 
    components: {
        //'app-layout-footer': LayoutFooter,
        'whats-new': WhatsNew,
        'error-view': ErrorView
    },
    data() {
        return {
            modalVisible: false,
            error: null,
            error_disable_dismiss: false
        }
    },
    methods: {
        onError: function(response, disableDismiss) {
            if (response) {
                if (response.status === 401) {
                this.$router.push("/signin")
                }
                else {
                    this.error = response.body;
                    this.error_disable_dismiss = disableDismiss
                }
            }
            else {
                this.error = {error_message:"An unknown error occured", request_id: "0"};
            }
        }
    },
    computed: {
        sessionUsername: function() {
            let username = null;
            const sessionJSON = localStorage.getItem('session') || '';
            if (sessionJSON.length) {
                const session = JSON.parse(sessionJSON);
                const sessionUsername = session.username || '';
                if (sessionUsername.length) {
                    username = sessionUsername;
                }
            }
            return username;
        },
        publicRoute: function() {
            const routeName = this.$route.name || '';
            return routeName.startsWith('public');
        }
    }
}
</script>

<style scoped>
.makeMeTransparent
{
    background-color: transparent;
}
.logoStyle {
    margin-left: 20px;
}
.logoCopyright {
    font-size:50%; 
    margin-left:12px; 
    vertical-align: bottom;
}
.topbarStyle {
   background: rgb(255,255,255);
    background: linear-gradient(90deg, rgba(255,255,255,1) 15%, rgba(0,30,87,1) 50%);

    height: 66px;

    }

.setOpacity {
    opacity: 0.99;
}

.footerLinkTitle {
    color: #666666;
}


</style>